// extracted by mini-css-extract-plugin
export default {"main":"register_main__zDX4z","box":"register_box__zJiju","icon":"register_icon__qQg+c"};